import ErrorType from '../constants/error-type';

export const isExpectedError = (name) => (
    name === ErrorType.FLASH_NOT_SUPPORTED ||
    name === ErrorType.GEO_BLOCK_ERROR ||
    name === ErrorType.IMMERSIVE_NOT_SUPPORTED_ERROR ||
    name === ErrorType.PROGRAM_NOT_STARTED_ERROR ||
    name === ErrorType.LIVE_NOT_STARTED_ERROR
);



// WEBPACK FOOTER //
// ./src/js/util/error.js